import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import ProfileV2 from "Platform/routes/ProfileV2";
export default store => ({
  path: "homeroom",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "homeroom" */ "./components"),
        import(/* webpackChunkName: "homeroom" */ "./modules/HomeroomModule"),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "homeroom",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [ProfileV2(store)],
});
